import { IconProps } from "@/data/types"

export default function ConciergeIcon({ width=32, height=32, color='#000000', className }: IconProps) {
  return  (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <path
          d="M8.17,1.5h7.65V8.2A3.83,3.83,0,0,1,12,12h0A3.83,3.83,0,0,1,8.17,8.2V1.5Z"
          stroke={color}
          strokeWidth="0.72"
          strokeMiterlimit="10"
        />
        <line
          x1="8.17"
          y1="5.33"
          x2="18.7"
          y2="5.33"
          stroke={color}
          strokeWidth="0.72"
          strokeMiterlimit="10"
        />
        <path
          d="M4.35,23.5V19.67A7.65,7.65,0,0,1,12,12h0a7.65,7.65,0,0,1,7.65,7.65V23.5"
          stroke={color}
          strokeWidth="0.72"
          strokeMiterlimit="10"
        />
        <line
          x1="9.13"
          y1="17.76"
          x2="11.04"
          y2="17.76"
          stroke={color}
          strokeWidth="0.72"
          strokeMiterlimit="10"
        />
        <line
          x1="9.13"
          y1="21.59"
          x2="11.04"
          y2="21.59"
          stroke={color}
          strokeWidth="0.72"
          strokeMiterlimit="10"
        />
        <polyline
          points="8.93 12.66 12.96 15.85 12.96 23.5"
          stroke={color}
          strokeWidth="0.72"
          strokeMiterlimit="10"
          fill="none"
        />
      </svg>
    </div>
  )
}